export default [
  {
    path: '/ci/received',
    name: 'CI - Recebidos',
    component: () => import('./ReceivedCi.vue'),
    meta: {
      requiresAuth: true,
      is_admin: true,
      name: 'ReceivedCi',
    },
  },
]
